import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import React, { useContext, useState } from "react";

const useEditAdterm = () => {
  const { lead } = useContext(LeadPageContext);
  const [editAdtermModalOpen, setEditAdtermModalOpen] = useState(false);
  const [adterm, setAdterm] = useState<string | null>(null);
  const handleChangeAdterm = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAdterm(e.target.value);
  };

  return {
    adterm: {
      editAdtermModalOpen,
      setEditAdtermModalOpen,
      handleChangeAdterm,
      state: adterm,
      setState: setAdterm,
      value: lead?.data?.lead?.adterm?.name,
    },
  };
};

export default useEditAdterm;
